import axios from 'axios';

export const init = () => { // eslint-disable-line import/prefer-default-export
  loadSearchResults();
  loadPaginationResults();
  setSearchFormAttributes();
  toggleSearchVisibility();
};

const setSearchFormAttributes = () => {
  const searchInput = document.querySelector('.search input[name="searchText"]');
  searchInput.setAttribute('placeholder', 'Search');
  searchInput.setAttribute('autocomplete', 'off');
};

const loadSearchResults = () => {
  const searchForm = document.getElementsByClassName('search__wrapper')[0].getElementsByTagName('form')[0];
  searchForm.addEventListener('submit', handleSearchSubmit, false);
};

const handleSearchSubmit = (event) => {
  event.preventDefault();
  const searchResults = document.getElementsByClassName('search__results')[0];
  const form = event.target;
  const formValues = [...form.getElementsByTagName('input')].map(input =>
    `${input.name}=${encodeURIComponent(input.value)}`).join('&');

  searchResults.innerHTML = '<img src="/assets/images/icon-loading.svg">';

  axios.get(`/index.cfm?${formValues}&overrideLayout=1`)
    .then((response) => {
      searchResults.innerHTML = response.data;
    })
    .catch((err) => {
      searchResults.innerHTML = err.data;
    });
};

const loadPaginationResults = () => {
  const paginationLinks = [...document.querySelectorAll('.searchPagination a')];
  paginationLinks.forEach((paginationLink) => {
    ['touchstart', 'click'].forEach(event => paginationLink.addEventListener(event, handlePagination, false));
  });
};

const handlePagination = (event) => {
  event.preventDefault();
  const searchResults = document.getElementsByClassName('search__results')[0];
  const href = event.target.getAttribute('href');

  searchResults.innerHTML = '<img src="/assets/images/icon-loading.svg">';

  axios.get(`${href}&overrideLayout=1`)
    .then((response) => {
      searchResults.innerHTML = response.data;
    })
    .catch((err) => {
      searchResults.innerHTML = err.data;
    });
};

const toggleSearchVisibility = () => {
  const searchToggles = [...document.getElementsByClassName('search__toggle')];
  const searchOverlay = document.getElementsByClassName('search')[0];
  searchToggles.forEach((searchToggle) => {
    ['touchstart', 'click'].forEach(event => searchToggle.addEventListener(event, (e) => {
      e.preventDefault();
      searchOverlay.classList.toggle('search--is-visible');
    }, false));
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/search.js